import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 56px;
  background-color: #f2f6ff;
  padding: 10px;
`;

const SingleTab = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledLink = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #002775;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 20px;
  width: 80%;
  height: 40px;
  border-radius: 10px;
  &.active {
    border-radius: 24px;
    border: 2px solid #144fc3;
    background-color: #144fc3;
    color: #fff;
  }
`;

const navLinksData = [
  {
    label: "Business Profile",
    to: "profile",
  },
  {
    label: "Timings",
    to: "timings",
  },
  {
    label: "Holidays",
    to: "holidays",
  },
];

const NavTabs = (props) => {
  return (
    <Container>
      {navLinksData.map((linkData, idx) => {
        return (
          <StyledLink key={idx} to={linkData.to}>
            {linkData.label}
          </StyledLink>
        );
      })}
    </Container>
  );
};

NavTabs.propTypes = {};

export { NavTabs };
